<template v-if="Object.keys(levels).length && !isLoading">
	<div class="row mb-1" v-show="isDateChange">
		<div class="col-2">
			<h5 style="padding-top: 10px">Gældende for:</h5>
		</div>
		<div class="col-4">
			<DatePicker
				:disabled="isPreview"
				v-model="applicableDate"
				:disableFutureDates="true"
			></DatePicker>
		</div>
	</div>
	<template v-for="(level, levelKey) in levels" :key="levelKey">
		<div
			v-if="level.questions.length > 0 && level.questions[0].hide == 0"
			class="mb-1"
		>
			<a id="headingCollapse1" @click="toggleExpansion(levelKey)">
				<div class="card-title lead">
					<div style="display: flex; align-items: center">
						<font-awesome-icon
							:icon="
								level.isExpanded
									? 'fa fa-arrow-up'
									: 'fa fa-arrow-down'
							"
							color="#3a73b8"
							width="1rem"
						></font-awesome-icon>
						<span
							v-tooltip:bottom-left="level.questions[0].help_text"
							class="moretitle w-100"
							>&nbsp; {{ level.questions[0].question }}</span
						>
					</div>
				</div>
			</a>
			<Collapse
				:when="level.isExpanded"
				class="v-collapse"
				style="margin-left: 20px"
			>
				<template
					v-for="(question, index) in level.questions"
					:key="question.id"
				>
					<div
						class="pt-1 d-flex"
						:class="question.type_id === 2 ? 'mb-2' : ''"
						style="flex-wrap: wrap"
						v-if="question.level > 1 && question.hide == 0"
						:style="{
							'margin-left': `${(question.level - 2) * 10}%`,
						}"
					>
						<!-- Headline -->
						<div
							class="mb-1 mr-1"
							ref="questionRefs"
							:level="question.level"
							style="word-break: break-word"
							:style="{
								width: `30ch`,
							}"
						>
							<h5
								v-if="question.type_id === 1"
								v-tooltip:bottom-left="question.help_text"
							>
								{{ question.question }}
							</h5>
							<p
								v-else
								v-tooltip:bottom-left="getHelpText(question.help_text, 0)"
								class="black"
								>{{ question.question }}</p
							>
						</div>
						<!-- Input field -->
						<template v-if="question.type_id === 7">
							<div style="width: 33.33%">
								<div class="group">
									<textarea
										:disabled="isPreview || !isEdit"
										v-model="answers[question.id]"
										class="form-control"
										type="text"
										@change="updateAnswer"
										:style="
											isJournalSummary
												? { backgroundColor: 'white' }
												: ''
										"
									></textarea>
									<span class="highlight"></span
									><span class="bar"></span>
									<label>Tekst</label>
								</div>
							</div>
						</template>
						<!-- Numerical input field -->
						<template v-if="question.type_id === 6">
							<div class="col p-0" style="max-width: 4rem">
								<div class="group" v-if="!isJournalSummary">
									<input
										:disabled="isPreview || !isEdit"
										v-model="answers[question.id]"
										class="form-control text-center numerical-input"
										style="padding-block: 1rem"
										@change="updateAnswer"
										type="number"
									/>
									<span class="highlight"></span
									><span class="bar"></span>
								</div>
								<div class="group" v-else>
									<input
										:disabled="isPreview || !isEdit"
										v-model="
											accumulatedAnswers[question.id]
										"
										class="form-control text-center"
										style="
											padding-block: 1rem;
											background-color: white !important;
										"
										type="text"
										@change="updateAnswer"
									/>
									<span class="highlight"></span
									><span class="bar"></span>
								</div>
							</div>
						</template>
						<!-- Yes/No field -->
						<template v-if="question.type_id === 4">
							<div
								class="grid-container"
								style="
									display: grid;
									grid-template-rows:
										minmax(min-content, max-content)
										4rem;
									gap: 0.5rem;
								"
							>
								<div
									class="d-flex pr-1"
									style="justify-content: space-between"
								>
									<template v-if="!isJournalSummary">
										<label class="customcheck">
											<input
												:disabled="isPreview || !isEdit"
												value="yes"
												v-model="answers[question.id]"
												type="radio"
												@change="updateAnswer"
											/>
											<div class="checkmark" />
										</label>
										<label style="width: 2rem" class="ml-1"
											>Ja</label
										>
									</template>
									<template v-else>
										<label class="mx-1">Ja</label>
										<div class="group">
											<input
												:disabled="isPreview || !isEdit"
												:value="
													getAnswer(question.id, 0)
												"
												class="form-control text-center"
												style="
													padding-block: 1rem;
													background-color: white !important;
													max-width: 4rem;
												"
												type="text"
												@change="updateAnswer"
											/>
											<span class="highlight"></span
											><span class="bar"></span>
										</div>
									</template>
								</div>
								<div
									class="d-flex pr-1"
									style="justify-content: space-between"
								>
									<template v-if="!isJournalSummary">
										<label class="customcheck">
											<input
												:disabled="isPreview || !isEdit"
												value="no"
												v-model="answers[question.id]"
												type="radio"
												@change="updateAnswer"
											/>
											<div class="checkmark" />
										</label>
										<label style="width: 2rem" class="ml-1"
											>Nej</label
										>
									</template>
									<template v-else>
										<label class="mx-1">Nej</label>
										<div class="group">
											<input
												:disabled="isPreview || !isEdit"
												:value="
													getAnswer(question.id, 1)
												"
												class="form-control text-center"
												style="
													padding-block: 1rem;
													background-color: white !important;
													max-width: 4rem;
												"
												type="text"
												@change="updateAnswer"
											/>
											<span class="highlight"></span
											><span class="bar"></span>
										</div>
									</template>
								</div>
							</div>
						</template>
						<!-- User-defined scale field -->
						<template v-if="question.type_id === 2">
							<div
								:ref="isJournalSummary ? 'gridContainers' : ''"
								class="grid-container"
								:level="isJournalSummary ? question.level : ''"
								style="display: grid; gap: 0.5rem"
								:style="{
									width: `30ch`,
								}"
							>
								<template
									v-for="(
										choice, index
									) of question.choices.split(',')"
									:key="index"
								>
									<div
										class="p-0 d-flex"
										v-tooltip:bottom-left="
											getHelpText(
												question.help_text,
												index + 1,
											)
										"
									>
										<template v-if="!isJournalSummary">
											<div class="d-flex">
												<label class="customcheck">
													<input
														:disabled="
															isPreview || !isEdit
														"
														type="checkbox"
														:value="choice.trim()"
														:checked="
															isChoiceSelected(
																question.id,
																choice.trim(),
															)
														"
														@change="
															choiceSelected(
																question.id,
																choice.trim(),
																index,
																$event.target
																	.checked,
															)
														"
													/>
													<div class="checkmark" />
												</label>
											</div>
											<div
												class="px-1"
												style="width: 30ch"
											>
												<template v-if="isEdit">
													<span
														class="black"
														style="
															word-break: break-word;
														"
														>{{ choice.trim() }}
													</span>
												</template>
												<template v-else>
													<div class="group">
														<input
															class="form-control"
															type="text"
															style="
																height: 26px;
																padding-top: 10px;
																pointer-events: none;
																background-color: white !important;
															"
															:value="
																choice.trim()
															"
														/>
														<span
															class="highlight"
														></span
														><span
															class="bar"
														></span>
													</div>
												</template>
											</div>
										</template>
										<template v-else>
											<label
												class="mr-1"
												style="width: 30ch"
												>{{ choice.trim() }}</label
											>
											<div class="group">
												<input
													:disabled="
														isPreview || !isEdit
													"
													:value="
														getAnswer(
															question.id,
															index,
														)
													"
													class="form-control text-center numerical-input"
													style="
														padding-block: 1rem;
														background-color: white !important;
														width: 4rem;
													"
													type="number"
													@change="updateAnswer"
												/>
												<span class="highlight"></span
												><span class="bar"></span>
											</div>
										</template>
									</div>
								</template>
							</div>
						</template>
						<!-- Date field -->
						<template v-if="question.type_id === 5">
							<div style="width: 33.33%">
								<DatePicker
									no-date
									:disabled="
										isPreview || !isEdit || isJournalSummary
									"
									v-model="answers[question.id]"
									@change="(e) => {
											answers[question.id] = e.value;
											$emit('answers', answers);
										}"
								></DatePicker>
							</div>
						</template>
						<!-- Attach file field -->
						<template v-if="question.type_id === 8">
							<div style="font-size: 12px; width: 33.33%">
								<div style="margin-bottom: 5px">
									<u>Vælg filer til upload:</u>
								</div>
								<div style="margin-bottom: 5px">
									Vælg flere filer ved at holde knapperne<br />
									"Shift" eller "Ctrl" nede og markér
									herefter<br />
									de ønskede filer
								</div>
								<input
									:disabled="isPreview || !isEdit"
									type="file"
									multiple
								/>
							</div>
						</template>
						<!-- Theme/topic field -->
						<template v-if="question.type_id === 3">
							<div style="width: 33.33%">
								<div class="group">
									<textarea
										:disabled="isPreview || !isEdit"
										v-model="answers[question.id]"
										class="form-control"
										type="text"
										@change="updateAnswer"
										:style="
											isJournalSummary
												? { backgroundColor: 'white' }
												: ''
										"
									></textarea>
									<span class="highlight"></span
									><span class="bar"></span>
									<label>Tekst</label>
								</div>
							</div>
						</template>
					</div>
				</template>
			</Collapse>
		</div>
	</template>
	<div
		v-if="!isPreview && isEdit && !isJournal"
		class="d-flex justify-content-end"
	>
		<button class="btn btn-primary" type="button" @click="submit()">
			Gem
		</button>
	</div>
</template>
<script setup>
import DatePicker from "@elements/datePicker/DatePicker.vue";

import moment from "moment";
import { computed, onBeforeMount, onMounted, reactive, ref } from "vue";
import { Collapse } from "vue-collapsed";
import vTooltip from "../../directives/tooltip";
import TemplateService from "../../services/TemplateService";
const service = new TemplateService();
const props = defineProps({
	template: Object,
	departmentId: Number,
	isPreview: Boolean,
	selectedQuestions: Object,
	date: {
		type: Date,
		default: () => new Date(),
	},
	isEdit: Boolean,
	templateHistory: {
		type: Array,
		default: () => [],
	},
	register: {
		type: Boolean,
		default: false,
	},
	isDateChange: Boolean,
	isJournal: Boolean, // Used for displaying the template in the journal module
	isJournalSummary: Boolean, // Used for displaying the accumulated data from the journal in the data registration
});

const isLoading = ref(true);
const levels = ref({});
const answers = reactive({});
const accumulatedAnswers = ref([]);
const existingAnswers = ref([]);
const applicableDate = ref(props.register ? new Date() : props.date);
const toggleExpansion = (levelKey) => {
	levels.value[levelKey].isExpanded = !levels.value[levelKey].isExpanded;
};

const traverseArray = async (arr, existingAnswers) => {
	let output = {};

	let levelCounter = 1;

	for (let i = 0; i < arr.length; i++) {
		const obj = arr[i];

		if (obj.level === 1) {
			const levelKey = `level_${levelCounter}`;
			output[levelKey] = {
				isExpanded: true,
				questions: [],
			};
			levelCounter++;
		}
		if (props.isPreview) {
			obj.hide = shouldHide(obj);
		}
		const levelKeys = Object.keys(output);
		const currentLevelKey = levelKeys[levelKeys.length - 1];

		// Create "answers" object inside the question
		const questionWithAnswers = {
			...obj,
			answers: {},
		};

		// Find the existing answer if it is available
		if (
			existingAnswers &&
			existingAnswers.length > 0 &&
			!props.isJournalSummary
		) {
			const existingAnswer = existingAnswers.find(
				(answer) => answer.question_id === obj.id,
			);
			if (existingAnswer && existingAnswer.answer !== null) {
				questionWithAnswers.answers[obj.id] =
					existingAnswer.answer.split(",");
			} else {
				questionWithAnswers.answers[obj.id] = null;
			}
		}

		output[currentLevelKey].questions.push(questionWithAnswers);
	}

	levels.value = output;
};
const shouldHide = (question) => {
	if (!props.isPreview) return;
	if (
		question.id in props.selectedQuestions &&
		props.selectedQuestions[question.id].hide == 0
	) {
		return 1;
	} else {
		return 0;
	}
};
const runTraversal = async (response) => {
	const arr = response.questions;
	await traverseArray(arr, existingAnswers.value);

	if (props.isJournalSummary) {
		props.templateHistory.forEach((answer, index) => {
			accumulatedAnswers.value[index] = answer;
		});
		isLoading.value = false;
	} else {
		for (const answer of existingAnswers.value) {
			const question = Object.values(levels.value)
				.flatMap((level) => level.questions)
				.find((q) => q.id === answer.question_id);

			if (question) {
				if (question.type_id === 4) {
					// Yes/No field
					answers[question.id] =
						answer.answer === "yes" ? "yes" : "no";
				} else if (question.type_id === 2) {
					// User-defined scale field
					const choices = answer.answer.split(",");
					answers[question.id] = {};
					choices.forEach((choice, index) => {
						answers[question.id][index] = choice.trim();
					});
				} else {
					// Other field types
					answers[question.id] = answer.answer;
				}
			}
		}
		isLoading.value = false;
	}
	updateAnswer();
};

const choiceSelected = (questionId, choice, index, isChecked) => {
	if (isChecked) {
		if (!answers[questionId]) {
			answers[questionId] = {};
		}
		if (typeof answers[questionId][index] === "undefined") {
			answers[questionId][index] = choice.trim();
		} else {
			choiceSelected(
				questionId,
				answers[questionId][index],
				index + 1,
				true,
			);
			answers[questionId][index] = choice.trim();
		}
	} else {
		if (isChoiceSelected(questionId, choice)) {
			for (let i = 0; i < Object.keys(answers[questionId]).length; i++) {
				if (
					answers[questionId][Object.keys(answers[questionId])[i]] ==
					choice
				) {
					delete answers[questionId][
						Object.keys(answers[questionId])[i]
					];
				}
			}
		}
	}
	updateAnswer();
};

const isChoiceSelected = (questionId, choice) => {
	const selectedChoices = answers[questionId] || {};
	return Object.values(selectedChoices).includes(choice);
};

let hasSubmitBeenClicked = false;
const submit = async () => {
	if (hasSubmitBeenClicked) {
		return;
	} else {
		hasSubmitBeenClicked = true;
	}
	let date = null;
	props.register ? (date = applicableDate.value) : (date = props.date);
	const formData = {
		template_id: props.template.id,
		department_id: props.departmentId ?? 0,
		questions: {},
		is_journal: "",
		date: moment(date).format("YYYY-MM-DD HH:mm:ss"),
		order: props.order ?? 1,
		is_create: props.isEdit && props.isDateChange,
	};

	let allQuestionsEmpty = true;

	for (const level of Object.values(levels.value)) {
		for (const question of level.questions) {
			const answer = answers[question.id];

			if (
				(answer !== null &&
					answer !== undefined &&
					String(answer).trim()) ||
				(answer !== null &&
					typeof answer === "object" &&
					Object.keys(answer).length !== 0)
			) {
				formData.questions[question.id] = answer;
				allQuestionsEmpty = false;
			}
		}
	}

	// In case of empty template, the template can still be saved
	if (Object.keys(formData.questions).length === 0) {
		loop1: for (const level of Object.values(levels.value)) {
			for (const question of level.questions) {
				if (question.type.id !== 1 && question.hide === 0) {
					formData.questions[question.id] = null;
					allQuestionsEmpty = true;
					break loop1;
				}
			}
		}
	}

	if (allQuestionsEmpty) {
		new swal({
			title: "Du er i gang med at gemme en dataregistrering uden data",
			text: "Er du sikker?",
			icon: "error",
			buttons: {
				cancel: {
					text: "Nej",
					className: "btn-bluedesign",
					value: false,
					visible: true,
					closeModal: true,
				},
				confirm: {
					text: "Ja",
					className: "btn-deletion",
					value: true,
					visible: true,
					closeModal: false,
				},
			},
		}).then((isAccepted) => {
			if (!isAccepted) {
				hasSubmitBeenClicked = false;
				return;
			} else {
				sendFormData(formData);
			}
		});
	} else {
		sendFormData(formData);
	}
};

async function sendFormData(formData) {
	try {
		await service
			.submit(formData)
			.then(() => {
				new swal({
					title: "",
					icon: "success",
					text: `Dataregistrering er ${props.isEdit && props.isDateChange ? "oprettet" : "opdateret"}`,
					type: "success",
					timer: 2000,
					closeModal: true,
					buttons: false,
				});
			})
			.then(sleeper(2000))
			.then(() => {
				emit("close");
			});
	} catch (error) {
		hasSubmitBeenClicked = false;
		console.log(error);
	}
}

function getHelpText(helpText, option) {
	const helpTextArr = helpText.split("::");
	return helpTextArr[option];
}

function sleeper(ms) {
	return function (x) {
		return new Promise((resolve) => setTimeout(() => resolve(x), ms));
	};
}

function updateAnswer() {
	emit("answers", answers);
}

const isNumber = (e) => {
	if (e.key.toLowerCase() == "e") return e.preventDefault();
	updateAnswer();
};

const computeAnswer = computed(() => {
	return accumulatedAnswers.value;
});

const getAnswer = (id, index) => {
	if (computeAnswer.value[parseInt(id)] !== undefined) {
		return Object.values(computeAnswer.value[parseInt(id)])[index];
	}
	return 0;
};

onBeforeMount(() => {
	isLoading.value = true;
	if (!props.register) {
		existingAnswers.value = props.templateHistory;
	}
	runTraversal(props.template);
});

onMounted(() => {});
defineExpose({ submit });
const emit = defineEmits(["close", "answers"]);
</script>
<style>
.custom-tooltip {
	--bs-tooltip-bg: #ffffff;
}
</style>
